<template>
  <div>
    {{ option.filter(item => item.value == value).map(item => item.label)[0] }}
  </div>
</template>

<script>
export default {
  name: "index",
  props: ['option', 'value'],
  created() {
  },
  mounted() {
    console.log(this.option, this.value)
  }
}
</script>

<style scoped>

</style>
